import { render } from "./score.vue?vue&type=template&id=1c5b769c&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"

import "./score.vue?vue&type=style&index=0&id=1c5b769c&lang=css"
import "./score.vue?vue&type=style&index=1&id=1c5b769c&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5b769c"]])

export default __exports__